import { IActivityConfiguration } from 'app/authoring/interfaces/IActivityComponent';
import { Metamodel } from 'app/model/base/model';
import { ActivityConfigurations } from 'app/authoring/registries/activity-configurations';

import { IfConditionActivity } from 'app/model/pipeline/if-condition.activity';
import { Pipeline } from 'app/model/pipeline/pipeline';
import { getActivityUrl } from 'app/shared/utils/links.util';

@ActivityConfigurations.register({})
export class IfConditionActivityConfiguration implements IActivityConfiguration {
    public label = stringResources.IfConditionActivityLabel;
    public name = 'If Condition';
    public activityType = Metamodel.modelFor(IfConditionActivity);
    public iconClass = 'svg-i_if_condition_16x16';
    public iconTransform = '';
    public categories = [stringResources.Activity_Category_Iteration];
    public supportedInTrident = true;
    public isKnownInPipelineContext = true;
    public docLink = getActivityUrl('ifCondition');

    public getTrueMappingProperty(ifConditionActivity: IfConditionActivity): Pipeline | undefined {
        return ifConditionActivity.ifTrueActivityPipeline;
    }

    public getFalseMappingProperty(ifConditionActivity: IfConditionActivity): Pipeline | undefined {
        return ifConditionActivity.ifFalseActivityPipeline;
    }

    public setMappingProperty(ifConditionActivity: IfConditionActivity, trueActivitiesPipeline?: Pipeline, falseActivitiesPipeline?: Pipeline): void {
        ifConditionActivity.ifTrueActivityPipeline = trueActivitiesPipeline;
        ifConditionActivity.ifFalseActivityPipeline = falseActivitiesPipeline;
    }
}
